export default __webpack_public_path__ + "media/download3x.a2b12fc1.png";